import _ from "lodash";

const useScore = () => {
  const handleData = (resData: any) => {
    const _data: any = _.cloneDeep(resData);
    let firstIndex = 0;
    let firstDepth1Name = _data?.at(0)?.depth1Name;
    let firstColSpan = 1;

    _data.forEach((item: any, index: number) => {
      if (index !== 0) {
        if (item.depth1Name === firstDepth1Name) {
          item.colSpan = 0;
          firstColSpan++;
        } else {
          _data[firstIndex].colSpan = firstColSpan;
          firstDepth1Name = item.depth1Name;
          firstColSpan = 1;
          firstIndex = index;
        }
      }
    });

    if (_data[firstIndex]) {
      _data[firstIndex].colSpan = firstColSpan;
    }

    return _data;
  }

  return {
    handleData,
  };
}

export default useScore;